import {
  Polygon as LeafletPolygon,
  LatLng,
  LeafletEvent,
  DivIcon,
  Point
} from 'leaflet';

import { Path, PathProps } from 'react-leaflet';

type Coordinates = LatLng[][];

interface EditableProps {
  options?: any;
  onChange?: (newPositions: Coordinates) => void;
}

type Props = PathProps &
  EditableProps & {
    positions: Coordinates;
  };

interface EditableLayer extends LeafletPolygon {
  editing: {
    enable: () => void;
    disable: () => void;
  };
}

export default class EditablePolygon extends Path<Props, EditableLayer> {
  constructor(props: Props) {
    super(props);
    this.state = {
      originalPositions: props.positions
    };
  }

  handleEdit = (evt: LeafletEvent) => {
    if (!this.props.onChange) {
      console.warn('polygon changed but nobody listenting');
      return;
    }
    this.props.onChange(evt.target.editing.latlngs[0] as Coordinates);
  };

  createLeafletElement(props: Props): EditableLayer {
    const enhancedOptions = {
      ...super.getOptions(props),
      poly: {
        icon: new DivIcon({
          iconSize: new Point(8, 8)
        })
      },
      editing: {}
    };

    const element = new LeafletPolygon(
      props.positions,
      enhancedOptions
    ) as EditableLayer;
    element.on('edit', this.handleEdit);
    element.editing.enable();

    return element;
  }
}



// WEBPACK FOOTER //
// ./src/components/EditablePolygon.tsx